import * as React from 'react';
import {observer} from 'mobx-react';
import * as classnames from 'classnames/bind';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {ListGridView} from '@mintdata-wsp/wsp/ui/components/grid/ListGridView';
import {PanelContentProps} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/layout/PanelView';

const styles = require('./ProblemsPanel.less');
const cx = classnames.bind(styles);

export interface ProblemsPanelProps extends PanelContentProps
{
}

@observer
export class ProblemsPanel extends React.Component<ProblemsPanelProps, any>
{
    render()
    {
        const gridModel = controllers.ui.panels.problems.getGridModel();

        return (
            <div className={cx('errorsPanel')}>
                <ListGridView gridModel={gridModel} />
            </div>
        );
    }
}
